var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { isPlainObject, omit } from 'lodash';
import { HelpersService } from '@base-shared/services/helpers.service';
var AppHttpClient = /** @class */ (function () {
    function AppHttpClient(http, translate, helpers) {
        this.http = http;
        this.translate = translate;
        this.helpers = helpers;
    }
    /**
    * GET Request
    * @param url request url
    */
    AppHttpClient.prototype.get = function (url, params) {
        var _this = this;
        //return this.http.get(url, this.getOptions())
        return this.http.get(url, { params: params, withCredentials: false })
            .pipe(map(this.extractData), catchError(function (error) { return _this.handleError(error); }));
    };
    /**
    * POST Request
    * @param url request url
    * @param payload payload object
    * @param [contentType] optional content type header
    */
    AppHttpClient.prototype.post = function (url, payload, contentType) {
        var _this = this;
        var customOptions = null;
        if (contentType) {
            var headers = new HttpHeaders({
                'Content-Type': contentType
            });
            customOptions = this.setCustomOptions(headers);
        }
        return this.http.post(url, payload, this.getOptions(customOptions))
            .pipe(map(this.extractData), catchError(function (error) { return _this.handleError(error); }));
    };
    /**
    * PATCH Request
    * @param url request url
    * @param payload payload object
    * @param [contentType] optional content type header
    */
    AppHttpClient.prototype.patch = function (url, payload, contentType) {
        var _this = this;
        var customOptions = null;
        if (contentType) {
            var headers = new HttpHeaders({
                'Content-Type': contentType
            });
            customOptions = this.setCustomOptions(headers);
        }
        return this.http.patch(url, payload, this.getOptions(customOptions))
            .pipe(map(this.extractData), catchError(function (error) { return _this.handleError(error); }));
    };
    /**
    * PUT Request
    * @param url request url
    * @param payload payload object
    * @param [contentType] optional content type header
    */
    AppHttpClient.prototype.put = function (url, payload, contentType) {
        var _this = this;
        var customOptions = null;
        if (contentType) {
            var headers = new HttpHeaders({
                'Content-Type': contentType
            });
            customOptions = this.setCustomOptions(headers);
        }
        return this.http.put(url, payload, this.getOptions(customOptions))
            .pipe(map(this.extractData), catchError(function (error) { return _this.handleError(error); }));
    };
    /**
    * DELETE Request
    * @param url request url
    * @param payload payload object
    */
    AppHttpClient.prototype.delete = function (url) {
        var _this = this;
        return this.http.delete(url, this.getOptions())
            .pipe(map(this.extractData), catchError(function (error) { return _this.handleError(error); }));
    };
    /**
     * Request options
     */
    AppHttpClient.prototype.getOptions = function (customOptions) {
        var options = {
            withCredentials: false
        };
        if (customOptions)
            options.headers = customOptions.headers || '';
        return options;
    };
    /**
    * Extract response from each request
    * @param res Endpoint response
    */
    AppHttpClient.prototype.extractData = function (res) {
        var body;
        // validate if response is not json
        try {
            body = res.json() || {};
        }
        catch (error) {
            body = res;
        }
        return body;
    };
    /**
   * Handle error if it's present on request
   * @param error Response error
   */
    AppHttpClient.prototype.handleError = function (error, from) {
        var message = this.errorMessage(this.getError(error), error.status);
        return throwError(message);
    };
    /**
     * Get error from body
     * @param error error description
     */
    AppHttpClient.prototype.getError = function (error) {
        var body = error;
        try {
            body = error.json() || {};
            body = isPlainObject(body.error) ? body.error :
                isPlainObject(body.error.error) ? body.error.error : body;
        }
        catch (e) {
            error = omit(error, ['headers', 'toString', 'json', 'blob', 'arrayBuffer', 'text']);
            body = error;
        }
        return body;
    };
    /**
     * Create an object with custom options
     * @param headers http headers
     */
    AppHttpClient.prototype.setCustomOptions = function (headers) {
        return {
            headers: headers || ''
        };
    };
    /**
   * Get message from HTTP error
   * or generate a custome one if status match an option
   * @param error Response Error
   * @param status Http code
   */
    AppHttpClient.prototype.errorMessage = function (error, status) {
        var message = {};
        switch (status) {
            case 404:
                message = __assign({}, error, { message: this.translate.instant('common.not-found') });
                break;
            case 401:
            case 403:
                message = __assign({}, error, { message: this.translate.instant('common.not-authorized') });
                break;
            case 500:
            case 405:
                message = __assign({}, error, { message: this.translate.instant('common.defaultServerError') });
                break;
            default:
                message = error;
                break;
        }
        return message;
    };
    return AppHttpClient;
}());
export { AppHttpClient };
